import {
  UPDATE_TAGS_REQUEST,
  UPDATE_TAGS_SUCCESS,
  UPDATE_TAGS_FAILURE,
  CLEAR_TAGS } from '../constants'
import { clear } from "redux-localstorage-simple"

const defaultTagsState = {
  tagList: [],
  updateSuccess: false
}

export default (state = defaultTagsState, action) => {

  var newState = {...state}

  switch (action.type){
    case UPDATE_TAGS_REQUEST:
      newState.updateSuccess = false;
      return newState;
    case UPDATE_TAGS_SUCCESS:
      newState.tagList = action.body;
      newState.updateSuccess = true;
      return newState;
    case UPDATE_TAGS_FAILURE:
      newState = defaultTagsState;
      return newState;
    case CLEAR_TAGS:
      newState = defaultTagsState;
      clear();
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tags.js